import { commonjsGlobal as e } from "../../_virtual/_commonjsHelpers.js";
var o = typeof e == "object" && e && e.Object === Object && e, l = o;
export {
  l as default
};
//# sourceMappingURL=_freeGlobal.js.map
